import React from "react";
import { Skeleton } from "../PainelShimmerChrome";
import "./MenuSectionSkeleton.scss";

const CARD_COUNT = 6;

interface MenuSectionSkeletonProps {
  sectionCount?: number;
  headerColors?: string[];
  borderColors?: string[];
  isDarkMode?: boolean;
}

const DEFAULT_HEADER_COLORS = ["#ED1C24", "#4190C1", "#009535"];
const DEFAULT_BORDER_COLORS = ["#FFB8BA", "#4190C1", "#4AC762"];
const DEFAULT_BORDER_COLORS_DARK = ["#5a2a2e", "#2a4a62", "#1f4a32"];

const MenuSectionSkeleton: React.FC<MenuSectionSkeletonProps> = ({
  sectionCount = 3,
  headerColors = DEFAULT_HEADER_COLORS,
  borderColors,
  isDarkMode = false,
}) => {
  const resolvedBorders =
    borderColors || (isDarkMode ? DEFAULT_BORDER_COLORS_DARK : DEFAULT_BORDER_COLORS);

  return (
    <div
      className={`menu-section-skeleton ${isDarkMode ? "menu-section-skeleton--dark" : ""}`}
      aria-busy="true"
      aria-label="Carregando painéis"
    >
      {Array.from({ length: sectionCount }, (_, sectionIndex) => (
        <section
          key={sectionIndex}
          className="menu-section-skeleton__section"
          style={{ borderColor: resolvedBorders[sectionIndex % resolvedBorders.length] }}
        >
          <div
            className="menu-section-skeleton__header"
            style={{ backgroundColor: headerColors[sectionIndex % headerColors.length] }}
          >
            <div className="menu-section-skeleton__header-title">
              <Skeleton height={18} width={220} baseColor="rgba(255,255,255,0.35)" highlightColor="rgba(255,255,255,0.65)" />
            </div>
            <Skeleton height={28} width={52} borderRadius={6} baseColor="rgba(255,255,255,0.35)" highlightColor="rgba(255,255,255,0.65)" />
          </div>

          <div className="menu-section-skeleton__grid">
            {Array.from({ length: CARD_COUNT }, (_, cardIndex) => (
              <div key={cardIndex} className="menu-section-skeleton__card">
                <Skeleton height={28} width={28} borderRadius={6} />
                <Skeleton height={14} width={140} borderRadius={4} />
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default MenuSectionSkeleton;
